/* Copyright 2013 - 2024 Waiterio LLC */
import get from './get.js'

export default function getPhrases(parameters, config) {
  let url = 'phrases'

  url += `?${new URLSearchParams(parameters).toString()}`

  return get({ retries: 3, ...config, url }).catch(error => {
    throw new Error(`Couldn't get phrases \n${error}`, { cause: error })
  })
}
